export interface FormValues {
  email: string;
}

export enum SubmissionStatus {
  OK = 'OK'
}
